import React, { useState } from 'react';
import Checklists from './Checklists';
import Locations from './Locations';
// import Metrics from './Metrics';
import Tags from './Tags';
import './styles.css';

const tabs = [
    { id: 'tags', label: 'Tags', component: Tags },
    { id: 'locations', label: 'Locations', component: Locations },
    // { id: 'metrics', label: 'Metrics', component: Metrics }, // Hide for now
    { id: 'checklists', label: 'Checklists', component: Checklists },
];

const Settings = () => {
    const [activeTab, setActiveTab] = useState('tags');
    const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component || Tags;

    return (
        <main className="stride-page-shell space-y-6">
            <header className="mb-6">
                <p className="stride-eyebrow">XCM configuration</p>
                <h1 className="text-2xl md:text-3xl stride-heading">Settings</h1>
                <span className="text-xs md:text-sm text-stride-muted mt-1 block">Manage reusable values used across your experimentation programme.</span>
            </header>
            <div className="stride-card overflow-hidden">
                <div className="flex gap-1 border-b border-border bg-surface px-6" role="tablist" aria-label="XCM settings">
                    {tabs.map((tab) => (
                        <button
                            id={`epm-settings-tab-${tab.id}`}
                            className={`relative border-0 py-4 px-5 bg-transparent text-xs md:text-sm font-semibold cursor-pointer transition-colors ${
                                activeTab === tab.id
                                    ? 'text-primary after:content-[""] after:absolute after:bottom-[-1px] after:left-3 after:right-3 after:h-0.5 after:bg-primary after:rounded-t'
                                    : 'text-stride-muted hover:text-stride-body'
                            }`}
                            key={tab.id}
                            type="button"
                            role="tab"
                            aria-selected={activeTab === tab.id}
                            aria-controls="epm-settings-panel"
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
                <section id="epm-settings-panel" className="min-h-[420px] p-6" role="tabpanel" aria-labelledby={`epm-settings-tab-${activeTab}`}>
                    <ActiveComponent />
                </section>
            </div>
        </main>
    );
};

export default Settings;
